module.exports = __webpack_public_path__ + "static/media/paper-portrait.b5123b92.svg";